import { render, staticRenderFns } from "./tlpay.vue?vue&type=template&id=2cd75b2a&scoped=true&"
import script from "./tlpay.vue?vue&type=script&lang=js&"
export * from "./tlpay.vue?vue&type=script&lang=js&"
import style0 from "./tlpay.vue?vue&type=style&index=0&id=2cd75b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd75b2a",
  null
  
)

export default component.exports